import { InsightBufferFile } from './types';

export const downloadFile = ({ content, filename }: InsightBufferFile): void => {
  const blob = new Blob([content]);

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.setAttribute('style', 'display: none');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
